import React, { Fragment } from "react";
import { Decimal, LiquityStoreState } from "@liquity/lib-base";
import { getContractAddressByCollateralKey } from "@liquity/lib-ethers";
import { useLiquitySelector } from "@liquity/lib-react";
import { CollateralLexicons, SLSD } from "../../lexicon";
import { TokenInfo } from "./TokenInfo";
import { useLiquity } from "src/hooks/LiquityContext";

type ResultSelector = {
  price: Decimal;
  balance: Decimal;
};

const select = ({ collateralStates }: LiquityStoreState) => {
  const selected = Object.entries(collateralStates).reduce<{
    [collateralKey: string]: ResultSelector;
  }>((acc, [key, value]) => {
    const { price, balance } = value;
    acc[key] = { price, balance };
    return acc;
  }, {});
  return { ...selected };
};

const selectSlsd = ({ slsdBalance }: LiquityStoreState) => {
  return { price: Decimal.ONE, balance: slsdBalance };
};

export const Prices: React.FC = props => {
  const priceList = useLiquitySelector(select);
  const slsdPrice = useLiquitySelector(selectSlsd);
  const {
    liquity: { connection }
  } = useLiquity();

  const chainId = connection.chainId;

  const assetPriceList = Object.entries(priceList).map(([key, result]) => {
    const { assetAddress } = getContractAddressByCollateralKey(connection, key);
    const lexicon = CollateralLexicons.find(lexicon => lexicon.key === key);

    return { key, lexicon, ...result, assetAddress };
  });

  const slsdTokenAddress = connection.addresses?.slsdToken;

  return (
    <div className="bg-component border-component p-6 flex flex-col h-fit w-full">
      {/* <div className="text-style-value">PSY Statistics</div> */}
      <div className="flex flex-row [&>*:nth-child(even)]:ml-12">
        {assetPriceList.map(({ key, lexicon, price, balance, assetAddress }, index) => (
          <Fragment key={index}>
            {!!assetAddress && !!lexicon && (
              <TokenInfo
                lexicon={lexicon}
                balance={balance}
                usdPrice={price}
                chainId={chainId}
                tokenAddress={assetAddress}
                priceType="oracle"
              />
            )}
          </Fragment>
        ))}
      </div>
      <div className="flex flex-row mt-6">
        <TokenInfo
          lexicon={SLSD}
          balance={slsdPrice.balance}
          usdPrice={slsdPrice.price}
          chainId={chainId}
          tokenAddress={slsdTokenAddress}
          priceType="market"
          // className="ml-12"
        />
      </div>
    </div>
  );
};
